import { useEffect, useState } from "react";
import { API, startSignIn } from "./auth";

// Protected gate for /erp. Server is the source of truth for authentication.
export default function ErpRoute({ children }) {
  const [authed, setAuthed] = useState(null); // null = checking, true, false

  useEffect(() => {
    const check = async () => {
      try {
        const response = await fetch(`${API}/auth/me`, { credentials: "include" });
        if (!response.ok) throw new Error("not authed");
        setAuthed(true);
      } catch (e) {
        setAuthed(false);
      }
    };
    void check();
  }, []);

  useEffect(() => {
    if (authed === false) startSignIn();
  }, [authed]);

  if (authed === null) {
    return (
      <div className="erp-loading" data-testid="erp-auth-checking">
        <div className="loading-brand">R<span>E</span></div>
        <div className="loading-spinner" />
        <h2>Opening your workspace</h2>
        <p>Connecting to Rollcon ERP…</p>
      </div>
    );
  }
  if (authed === false) {
    return (
      <div className="erp-loading" data-testid="erp-redirect-signin">
        <div className="loading-spinner" />
        <h2>Redirecting to sign-in…</h2>
      </div>
    );
  }
  return children;
}
